/**
 * Centralized map provider types and helpers — frontend side.
 * Contract mirror of the backend `/api/tiles/config` endpoint response.
 */

export interface MapProviderOption {
  id: string;
  name: string;
  tileUrl: string;
  attribution: string;
  tileSize: 256 | 512;
  maxzoom: number;
  isSatellite?: boolean;
}

export interface TileConfig {
  defaultProviderId: string;
  providers: MapProviderOption[];
  terrain: {
    encoding: 'mapbox' | 'terrarium';
    maxZoom: number;
    tileUrl: string;
  };
}

export function getProvider(config: TileConfig, id: string): MapProviderOption {
  return config.providers.find((p) => p.id === id)
    ?? config.providers.find((p) => p.id === config.defaultProviderId)
    ?? config.providers[0];
}
